module.exports = __webpack_public_path__ + "img/events.11e9952b.svg";